import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { CompanyInvoice } from 'src/app/models/companyInvoice.model';

@Injectable({
    providedIn: 'root'
})
export class PaymentApi extends Api<CompanyInvoice> {
    
}